import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Package, DownloadSimple } from "@phosphor-icons/react";
import API from "../../../lib/api";
import { Button } from "../../ui/button";
import { KINDS, err } from "./libraryUtils";

/** Platform library: the catalogue bundled with the app vs this environment — one tap installs whatever is missing (new deployments start empty). */
export function StarterPackBanner({ onInstalled }) {
  const [st, setSt] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => API.get("/platform/hs-library/starter-pack").then((r) => setSt(r.data)).catch(() => setSt(null));
  useEffect(() => { load(); }, []);
  if (!st || st.missing === 0) return null;

  const install = async () => {
    setBusy(true);
    try {
      const res = (await API.post("/platform/hs-library/starter-pack/install")).data;
      toast.success(res.message);
      setSt(res);
      onInstalled?.();
    } catch (e) { err(e, "Couldn't install the starter pack"); } finally { setBusy(false); }
  };
  const parts = KINDS.filter((k) => st.missing_by_kind[k.key]).map((k) => `${st.missing_by_kind[k.key]} ${st.missing_by_kind[k.key] === 1 ? k.label : k.plural}`);
  return (
    <div className="rounded-lg border border-primary/50 bg-primary/5 p-4 flex flex-wrap items-center gap-3" data-testid="lib-starter-pack">
      <Package size={22} weight="fill" className="text-primary shrink-0" />
      <div className="flex-1 min-w-[240px]">
        <p className="text-sm font-semibold">Fixlr starter pack — {st.missing} of {st.total} items not in this library yet</p>
        <p className="text-xs text-muted-foreground mt-0.5" data-testid="lib-starter-pack-breakdown">{parts.join(" · ")}. Installs as published v1; anything already here is left untouched.</p>
      </div>
      <Button size="sm" disabled={busy} onClick={install} data-testid="lib-starter-pack-install"><DownloadSimple size={14} className="mr-1" /> {busy ? "Installing…" : `Install ${st.missing} item${st.missing === 1 ? "" : "s"}`}</Button>
    </div>
  );
}
